module.exports = {
  "OEbranch": "master",
  "AIBase": "zh_cn",
  "moduleName": "H5-soda-fe-gattaran-common-gattaran-workshop-i18n",
  "filePath": "/src/i18n",
  "prefix": "gattaran-workshop-i18n---",
  "noParse": true,
  "version": 0,
  "script": "//img0.didiglobal.com/static/copywriter_h5/H5-soda-fe-gattaran-common-gattaran-workshop-i18n/src/i18n/all.js"
}